import moment from "moment";
import React from "react";
import { DraftProposalStatus } from "../../../../../core";
import { FeeConfirmationTabNames } from "../props";

interface UploadFeeLetterHeaderProps {
    currentDocument: any;
    isSaving: boolean;
    onSend: (documentCopyType: string) => Promise<void>;
    proposalDocument: any;
    onClose: (() => void) | undefined;
    documentId: string;
    title: string | undefined;
    showAcceptButton: boolean | undefined;
    showRejectButton: boolean | undefined;
    setDocumentId: React.Dispatch<React.SetStateAction<string>>
    setOpenApprovalModal: React.Dispatch<React.SetStateAction<{
        isOpen?: boolean;
        approvalType?: string;
        user?: string[];
    }>>
    setShowEdit: React.Dispatch<React.SetStateAction<boolean>>
    setStatusModalOpen: React.Dispatch<React.SetStateAction<{
        isOpen?: boolean;
        status?: DraftProposalStatus;
        documentCopyType?: string;
    }>>
    showEdit: boolean;
    tabName: FeeConfirmationTabNames;
}


export function UploadFeeLetterHeader({ currentDocument,
    documentId,
    isSaving,
    onSend,
    proposalDocument,
    setDocumentId,
    setOpenApprovalModal,
    setShowEdit,
    setStatusModalOpen,
    showEdit,
    tabName,
    showAcceptButton,
    showRejectButton,
    onClose
}: UploadFeeLetterHeaderProps) {

    const getStatus = () => {
        if (currentDocument?.internalApproval?.status === "Approved") {
            return "Internally Approved";
        }
        if (currentDocument?.internalApproval?.status === "Rejected") {
            return "Internally Rejected";
        }
        if (currentDocument?.internalApproval?.status === "Pending") {
            return "Internal Approval Pending";
        }
        return "Draft";
    };


    return (
        <div className="container-fluid border-bottom py-3 proposal-head">
            <div className="d-flex align-items-center">
                <>
                    <div
                        className="col-auto px-0"
                        onClick={() => {
                            if (showEdit) {
                                setShowEdit(false);
                            } else if (documentId !== documentId) {
                                setDocumentId(documentId);
                            } else {
                                onClose?.();
                            }
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                        >
                            <path
                                d="M25.0416 0.292893C24.6511 -0.0976308 24.0179 -0.0976312 23.6274 0.292893L12.6673 11.253L1.70711 0.292893C1.31658 -0.0976312 0.683417 -0.0976308 0.292893 0.292893C-0.0976308 0.683417 -0.0976312 1.31658 0.292893 1.70711L11.253 12.6673L0.292893 23.6274C-0.0976308 24.0179 -0.0976308 24.6511 0.292893 25.0416C0.683417 25.4322 1.31658 25.4322 1.70711 25.0416L12.6673 14.0815L23.6274 25.0416C24.0179 25.4322 24.6511 25.4322 25.0416 25.0416C25.4322 24.6511 25.4322 24.0179 25.0416 23.6274L14.0815 12.6673L25.0416 1.70711C25.4322 1.31658 25.4322 0.683417 25.0416 0.292893Z"
                                fill="#6F7171"
                            />
                        </svg>
                    </div>
                    <div className="col">
                        {proposalDocument?.proposedPropertyDetails.map((element: any, index: number) => (
                            <>
                                <div className=" d-flex align-items-center">
                                    <label className="font-md font-weight-semibold mb-0 ">
                                        {
                                            element?.propertyDetails
                                                ?.propertyDetailsFromProject?.projectName
                                        }{" "}
                                        / Floor :{" "}
                                        {
                                            element?.propertyDetails
                                                ?.propertyDetailsFromProject?.floor
                                        }{" "}
                                        / Unit :{" "}
                                        {
                                            element?.propertyDetails
                                                ?.propertyDetailsFromProject?.unitName
                                        }{" "}
                                        / Area :{" "}
                                        {
                                            element?.propertyDetails
                                                ?.propertyDetailsFromProject?.area
                                        }
                                    </label>
                                    {!!(proposalDocument.proposedPropertyDetails.length === index + 1) && <>
                                        {!currentDocument?.clientApproval &&
                                            !currentDocument?.landlordApproval ? (
                                            <span
                                                className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                                            >
                                                {getStatus()}
                                            </span>
                                        ) : (
                                            <>
                                                {!!currentDocument?.clientApproval && (
                                                    <span
                                                        className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                                                    >
                                                        {currentDocument?.clientApproval.status === "Pending"
                                                            ? "Sent to Client"
                                                            : "Client Approved"}
                                                    </span>
                                                )}
                                                {!!currentDocument?.landlordApproval && (
                                                    <span
                                                        className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                                                    >
                                                        {currentDocument?.landlordApproval.status ===
                                                            "Pending"
                                                            ? "Sent to Owner"
                                                            : "Vendor/Owner Approved"}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </>}
                                </div>
                                {!!(proposalDocument.proposedPropertyDetails.length === index + 1) && <span className="d-block  font-xs text-gray-500 font-weight-semibold">
                                    Created By{" "}
                                    <span className="text-dark">
                                        {proposalDocument?.createdBy?.name}
                                    </span>{" "}
                                    on{" "}
                                    <span className="text-dark">
                                        {moment(proposalDocument?.createdAt).format(
                                            "DD MMM YYYY hh:mm A"
                                        )}
                                    </span>
                                </span>}
                            </>
                        ))}
                    </div>

                    <div className="col-auto mt-md-0 mt-1 ml-auto">
                        {tabName === FeeConfirmationTabNames.ClientFeeConfirmation && (
                            <>
                                {proposalDocument?.document?.status === "Draft" &&
                                    !proposalDocument?.document?.internalApproval && (
                                        <button
                                            type="button"
                                            onClick={() => onSend("Client Copy")}
                                            className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                            disabled={isSaving}
                                        >
                                            Send For Internal Approval
                                        </button>
                                    )}

                                {proposalDocument?.document?.internalApproval?.status ===
                                    "Pending" && (
                                        <>
                                            {showRejectButton && <button
                                                type="button"
                                                onClick={() => {
                                                    setStatusModalOpen({
                                                        isOpen: true,
                                                        status: DraftProposalStatus.Rejected,
                                                        documentCopyType: "Client Copy",
                                                    });
                                                }}
                                                className="btn btn-outline-primary bg-white text-primary px-4 font-normal font-weight-bold py-2 rounded mx-2 "
                                                disabled={isSaving}
                                            >
                                                Reject
                                            </button>}
                                            {showAcceptButton && <button
                                                type="button"
                                                onClick={() => {
                                                    setStatusModalOpen({
                                                        isOpen: true,
                                                        status: DraftProposalStatus.Approved,
                                                        documentCopyType: "Client Copy",
                                                    });
                                                }}
                                                className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                                disabled={isSaving}
                                            >
                                                Approve
                                            </button>}
                                        </>
                                    )}
                                {proposalDocument?.document?.internalApproval?.status ===
                                    "Approved" &&
                                    !proposalDocument?.document?.clientApproval && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setOpenApprovalModal({
                                                    isOpen: true,
                                                    approvalType: "Client",
                                                })
                                            }
                                            className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                            disabled={isSaving}
                                        >
                                            Send For Client Approval
                                        </button>
                                    )}
                            </>
                        )}

                        {tabName === FeeConfirmationTabNames.LandLordFeeConfirmation && (
                            <>
                                {proposalDocument?.seperateDocumentForLandlord?.status ===
                                    "Draft" &&
                                    !proposalDocument?.seperateDocumentForLandlord
                                        ?.internalApproval && (
                                        <button
                                            type="button"
                                            onClick={() => onSend("Landlord Copy")}
                                            className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                            disabled={isSaving}
                                        >
                                            Send For Internal Approval
                                        </button>
                                    )}
                                {proposalDocument?.seperateDocumentForLandlord?.internalApproval
                                    ?.status === "Pending" && (
                                        <>
                                            {showRejectButton && <button
                                                type="button"
                                                onClick={() => {
                                                    setStatusModalOpen({
                                                        isOpen: true,
                                                        status: DraftProposalStatus.Rejected,
                                                        documentCopyType: "Landlord Copy",
                                                    });
                                                }}
                                                className="btn btn-outline-primary bg-white text-primary px-4 font-normal font-weight-bold py-2 rounded mx-2 "
                                                disabled={isSaving}
                                            >
                                                Reject
                                            </button>}
                                            {showAcceptButton && <button
                                                type="button"
                                                onClick={() => {
                                                    setStatusModalOpen({
                                                        isOpen: true,
                                                        status: DraftProposalStatus.Approved,
                                                        documentCopyType: "Landlord Copy",
                                                    });
                                                }}
                                                className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                                disabled={isSaving}
                                            >
                                                Approve
                                            </button>}
                                        </>
                                    )}
                                {proposalDocument?.seperateDocumentForLandlord?.internalApproval
                                    ?.status === "Approved" &&
                                    !proposalDocument?.seperateDocumentForLandlord
                                        ?.landlordApproval && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setOpenApprovalModal({
                                                    isOpen: true,
                                                    approvalType: "Landlord",
                                                })
                                            }
                                            className="btn btn-primary px-4 font-normal font-weight-bold py-2 rounded"
                                            disabled={isSaving}
                                        >
                                            Send For Vendor / Owner Approval
                                        </button>
                                    )}
                            </>
                        )}
                    </div>
                </>
            </div>
        </div>
    );
}
